import React from 'react';
import { useAppSelector } from '../../redux/hooks';
import { analysesVisitsSelector } from '../../redux/selectors/analysesVisits';
import { ChartMode } from '../Chart/types';
import { ChartLoader } from '../Chart';

interface IProps {
  analysisId: string;
}

const ExecutionHistoryLoader = ({ analysisId }: IProps) => {
  // Because report data is still loading, we will try to get data from history
  const analysesVisitsList = useAppSelector(analysesVisitsSelector);
  const analysisFromHistory = analysesVisitsList?.find(
    (analysisVisit) => analysisVisit.id === analysisId,
  );
  const display = analysisFromHistory?.display ?? '';

  return <ChartLoader mode={ChartMode.Build} display={display} />;
};

export default ExecutionHistoryLoader;
